module.exports = __webpack_public_path__ + "static/media/money-growth1.73c96085.svg";